import axios from "axios";

export const setPhoneGa4EventToService = async ({ listingId, eventName, reason }) => {
  const viewedPhone = eventName === "call" ? "detail" : "phone";
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/listing/${listingId}/view-${viewedPhone}?reason=${reason}`;

  const response = await axios.get(url);
  return response;
};
